import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PluralTranslator',
  props: {
    count: {},
    translationKey: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, _toDisplayString(_unref(t)(_ctx.translationKey, { count: _ctx.count })), 1))
}
}

})